/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckIcaoSex {
    M = 'M',
    F = 'F',
    X = 'X'
}


export function instanceOfPaxCheckIcaoSex(value: any): boolean {
    for (const key in PaxCheckIcaoSex) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckIcaoSex, key)) {
            if (PaxCheckIcaoSex[key as keyof typeof PaxCheckIcaoSex] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckIcaoSexFromJSON(json: any): PaxCheckIcaoSex {
    return PaxCheckIcaoSexFromJSONTyped(json, false);
}

export function PaxCheckIcaoSexFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckIcaoSex {
    return json as PaxCheckIcaoSex;
}

export function PaxCheckIcaoSexToJSON(value?: PaxCheckIcaoSex | null): any {
    return value as any;
}

export function PaxCheckIcaoSexToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckIcaoSex {
    return value as PaxCheckIcaoSex;
}

